enum Dictionary {
  title = 'New campaign',
  description = 'Create a referral campaign in order to engage new customers to Twism. Give it a name and select the amount of Coins to be rewarded.',
  labelTitle = 'Campaign title',
  labelCoins = 'Coins to be rewarded',
  labelSearch = 'Search by business name',
  labelSubmit = 'Create a new campaign',
  selectBusinesses = 'Select businesses to be in this campaign',
  selectBusinessesDescription = 'Make sure selected businesses are aligned to "Campaign Title". Once the campaign is ready, users will receive a banner on their mobile apps.'
}
export default Dictionary;
